import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import { render } from "storyblok-rich-text-react-renderer";


import Graph from "../Graph";
import "./Fifth.scss";

const Fifth = (props) => {
  console.log("fifth",props);
  const rawCardData = props?.data?.cards?.Cards?.length
    ? props?.data?.cards?.Cards
    : (props?.data?.pagedata || []);
  const carddata = rawCardData.filter(
    (item) => item?.component === "FifthSection" || item?.content
  );
  
  const logoArray1 = [
    "https://www.pngmart.com/files/8/Amazon-PNG-Pic.png",
    "https://www.freepnglogos.com/uploads/flipkart-logo-png/flipkart-logo-transparent-vector-3.png",
    "https://1000logos.net/wp-content/uploads/2021/04/Adobe-logo.png",
    "https://download.logo.wine/logo/Oracle_Cloud_Platform/Oracle_Cloud_Platform-Logo.wine.png",
    "https://seekvectorlogo.com/wp-content/uploads/2019/11/informatica-vector-logo.png",
    "https://download.logo.wine/logo/Zoho_Corporation/Zoho_Corporation-Logo.wine.png",
    "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Freshworks-vector-logo.svg/2048px-Freshworks-vector-logo.svg.png",
    "https://1000logos.net/wp-content/uploads/2020/04/Commscope-Logo.png",
    // "https://images.hasgeek.com/embed/file/a0baca393d534736b152750c7bde97f1",
    // "https://devrev.ai/images/og-image.png",
    "https://arizent.brightspotcdn.com/dims4/default/817e023/2147483647/strip/true/crop/498x210+0+0/resize/840x354!/quality/90/?url=https%3A%2F%2Fsource-media-brightspot.s3.amazonaws.com%2F94%2F11%2F884ef3324e1aba53216aaa32afa9%2Ftiger-analytics.png",
    "https://mms.businesswire.com/media/20200902005342/en/817754/23/Mr._Cooper_logo_thumbnail.jpg",
    "https://download.logo.wine/logo/Robert_Bosch_GmbH/Robert_Bosch_GmbH-Logo.wine.png",
  ];
  const logoArray2 = [
    "https://vtlogo.com/wp-content/uploads/2021/07/temenos-vector-logo.png",
    "https://cionews.co.in/wp-content/uploads/2022/08/Agg-6-7.png",
    // "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Tata_Consultancy_Services_Logo.svg/1200px-Tata_Consultancy_Services_Logo.svg.png",
    "https://1000logos.net/wp-content/uploads/2021/08/Capgemini-Logo.png",
    "https://w7.pngwing.com/pngs/926/247/png-transparent-wipro-consumer-care-lighting-ltd-job-business-information-technology-business-text-service-people.png",
    "https://download.logo.wine/logo/Athenahealth/Athenahealth-Logo.wine.png",
    "https://dl6pgk4f88hky.cloudfront.net/2021/12/Hexaware-logo.png",
    "https://mma.prnewswire.com/media/660270/Rfpio_logo_green_blue_Logo.jpg?p=facebook",
    "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Infosys_logo.svg/1280px-Infosys_logo.svg.png",
    "https://kebs.ai/wp-content/uploads/2023/06/kaar-removebg-preview.png",
    "https://www.grootan.com/static/og-grootan-ba42b86aed1a71bc869263782bd6aaf4.jpg",
    // "https://image.pitchbook.com/73svCaCNCSYyKTOq7ZLoGRFq6Cu1567110393061_200x200",
    // "https://signeasy.com/blog/wp-content/uploads/2021/11/Rectangle-blue-logo-1-1024x353.png",
    // "https://allvectorlogo.com/img/2016/10/virtusa-logo.png",
  ];

  const graphProp = props?.data?.pagedata?.[1];

  return (
    <div className="Fifth">
      <div className="Student">
        <h1>
          Our Commitment Towards Mentorship <br /> Makes Us Unique
        </h1>
      </div>

      {/* Swiper Slider Section */}
      {carddata.length > 0 && (
        <Swiper
          spaceBetween={30}
          slidesPerView={2}
          pagination={{ clickable: true }}
          navigation={true}
          modules={[Pagination, Navigation]}
          className="swiper-container"
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            424: {
              slidesPerView: 1,
            }
          }}
        >
          {carddata.map((item, index) => (
            <SwiperSlide key={index}>
              {item?.component === "FifthSection" ? (
                <div className="screenshot-container image-only-card">
                  <img
                    src={item?.image?.filename}
                    alt={item?.image?.alt || "LinkedIn post"}
                    className="linkedin-post-image"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                </div>
              ) : (
                <div className="screenshot-container">
                  <div className="top-row">
                    <div className="profile-section">
                      <img
                        src={item?.image?.filename}
                        alt={item?.image?.alt || "Profile"}
                        className="profile-img"
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                        }}
                      />
                      <div className="info">
                        <div className="name-line">
                          <span className="name">{item.name}</span>
                          <span className="dot"> • {item.connection}</span>
                        </div>
                        <div className="title">{item.designation}</div>
                        <div className="timestamp">{item.date}</div>
                      </div>
                    </div>
                    <div className="actions">
                      &nbsp;&nbsp; <div className="follow">+ Follow</div>
                      <div className="dots">⋯</div>
                    </div>
                  </div>
                  <div className="post-body">
                    {item?.content ? render(item.content) : null}
                  </div>
                </div>
              )}
            </SwiperSlide>
          ))}
          {/* Add more <SwiperSlide> blocks here for testing */}
        </Swiper>
      )}

      {/* Company Logos Section */}
      <div className="mt-10">
        <h1
          className="font-poppins text-center font-extrabold text-[#053859] my-5"
          style={{
            fontSize: "clamp(30px, 2.8vw, 5vw)",
            lineHeight: "clamp(40px, 3.5vw, 4vw)",
          }}
        >
          Our Graduates Pathway To Success
        </h1>
        <div className="flex items-center justify-center flex-wrap my-10 px-10">
          <div className="relative overflow-hidden w-full h-[175px]">
            <div className="flex animate-scroll-x my-10">
              {logoArray1.concat(logoArray1).map((elem, index) => (
                <img
                  key={index}
                  src={elem}
                  alt={`Logo ${index}`}
                  className="h-[125px] w-[200px] p-[15px] rounded-lg shadow-md mx-[15px]"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              ))}
            </div>
          </div>
          <div className="relative overflow-hidden w-full h-[175px] mt-6">
            <div className="flex animate-scroll-x-reverse py-5">
              {logoArray2.concat(logoArray2).map((elem, index) => (
                <img
                  key={index}
                  src={elem}
                  alt={`Logo ${index}`}
                  className="h-[125px] w-[200px] p-[15px] rounded-lg shadow-md mx-[15px]"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <br></br>

      <div className="Placements">
        <h1 style={{ textAlign: "center" }}>
          Full Stack Web Development Using MERN Stack In 15 Days, Students Momentous Transformations
        </h1>
        <Graph data={graphProp} />
      </div>
    </div>
  );
};

export default Fifth;
